import React, { Component } from "react";
import PropTypes from "prop-types";
import { Button, Modal } from "semantic-ui-react";
import { observer } from "mobx-react";
import Alert from "../stores/Alert";

@observer
class AlertWidget extends Component {
  render() {
    const { store } = this.props;
    const { isOpen, header, content } = store;
    const { size } = this.props;

    return (
      <div>
        <Modal size={size} open={isOpen} onClose={() => store.close()}>
          <Modal.Header>{header}</Modal.Header>
          <Modal.Content>
            <p>{content}</p>
          </Modal.Content>
          <Modal.Actions>
            <Button positive icon="checkmark" labelPosition="right" content="Close" onClick={() => store.close()} />
          </Modal.Actions>
        </Modal>
      </div>
    );
  }
}

AlertWidget.propTypes = {
  store: PropTypes.instanceOf(Alert),
  size: PropTypes.oneOf(["mini", "tiny", "small", "large", "fullscreen"]),
};

AlertWidget.defaultProps = {
  size: "mini",
};

export default AlertWidget;
